import { render, staticRenderFns } from "./tnc-jp.vue?vue&type=template&id=fbc5ceca&scoped=true"
import script from "./tnc-jp.vue?vue&type=script&lang=js"
export * from "./tnc-jp.vue?vue&type=script&lang=js"
import style0 from "./tnc-jp.vue?vue&type=style&index=0&id=fbc5ceca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc5ceca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbc5ceca')) {
      api.createRecord('fbc5ceca', component.options)
    } else {
      api.reload('fbc5ceca', component.options)
    }
    module.hot.accept("./tnc-jp.vue?vue&type=template&id=fbc5ceca&scoped=true", function () {
      api.rerender('fbc5ceca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-jp.vue"
export default component.exports